<template>
	<div id="actividad">
		<div class="card">
			<div class="card-header">
				<h3>Agregar Actividad</h3>
			</div>

			<div class="card-body row">
				<div class="col-md-4 mb-3 text-left">
          <label>Actividad:</label>
          <input class="form-control" type="text" placeholder="Actividad" v-model="nombreActividad">
        </div>

        <div class="offset-md-4 col-md-4 mb-3 p-4">
          <button class="btn btn-success" @click="agregarActividad">Agregar</button>
          <button class="btn btn-danger" @click="cancelarActividad">Cancelar</button>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
  import { bus } from '../main';
	import axios from 'axios';
	import Toastr from 'toastr';
  import Store from '../store/index';

	export default {
		name: 'Actividad',
		data () {
			return {
				nombreActividad: ''
			}
		},
		methods: {
			// Agrega la actividad insertada
			agregarActividad: function() {
				var self = this;
				var servicio = 'AgregarActividad';
				var exito = function (response) {
					console.log(response.data);
					if (response.data.Msg == 'Error') {
						Toastr.error("Hubo un problema al tratar de insertar la actividad.");
					} else if (response.data.Msg == 'Clave incorrecta') {
						Toastr.info("Debe ingresar una clave de usuario válida.");
					} else {
						Toastr.success("Actividad agregada con éxito.");
					}
				};

				var error = function (error) {
					Toastr.error("Hubo un problema al tratar de insertar la actividad.");
				};

				let a = {
					clave: Store.state.clave,
					proyecto: Store.state.proyecto,
					actividad: self.nombreActividad
				};

				if (a.actividad != '') {
					self.servicioPost(servicio, a, exito, error);
				} else {
					Toastr.info("Es necesario agregar un nombre de actividad.");
				}
			},

			// Cierra la sección de agregar actividad
			cancelarActividad: function() {
				this.nombreActividad = '';

				bus.$emit('AgregarActividad');
			},

			// Procesa un servicio web de tipo GET
      servicioGet: function(servicio, exito, error) {
        var url = 'http://tiempo.getpost.com.mx/WS/Timer' + servicio + '.php';

        axios.get(url, {})
        .then(exito)
        .catch(error);
      },

      // Procesa un servicio web de tipo POST
      servicioPost: function(servicio, parametro, exito, error) {
        var url = 'http://tiempo.getpost.com.mx/WS/Timer' + servicio + '.php';

        axios.post(url, parametro)
        .then(exito)
        .catch(error);
      }
		}
	}
</script>

<style scoped><

/style>


// WEBPACK FOOTER //
// src/components/Actividad.vue